import { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { server } from "../../server";
import axios from "axios";
import {
  basicQualificationList,
  classList,
  departmentList,
  designationList,
  masterQualificationList,
  professionalQualificationList,
  sectionList,
} from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import MySwal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getDecodedToken } from "../../auth";

function UpdateStaff() {
  const navigate = useNavigate();
  const [transport, setTransport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staffData, setStaffData] = useState(null);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const { state } = useLocation();
  const staffId = state?.staffId;
  const [user, setUser] = useState(null);
  const MySweetAlert = withReactContent(MySwal);

  const [mobileLocked, setMobileLocked] = useState(true);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);
  const otpInputsRef = useRef([]);

  useEffect(() => {
    const decodedData = getDecodedToken();
    if (decodedData) {
      setUser(decodedData);
    }
  }, []);

  const userRole = user?.roles;
  const userId = user?.userId;

  const [formData, setFormData] = useState({
    staffId: staffId,
    session: "2025-26",
    basicDetails: {
      initials: "",
      fullName: "",
      gender: "",
      fathersName: "",
      mothersName: "",
      spouseName: "",
      category: "",
      bloodGroup: "",
      religion: "",
      nationality: "",
      dob: "",
      doj: "",
      maritalStatus: "",
      mobNo: "",
      emailId: "",
      aadharNo: "",
      panNo: "",
      basicQualification: "",
      masterQualification: "",
      professionalQualification: "",
      correspondenceAddress: "",
      permanentAddress: "",
      staffImage: "",
    },
    leaveDetails: {
      totalCl: "",
      clAvailed: "",
      totalMl: "",
      mlAvailed: "",
    },
    categoryDetails: {
      staffCategory: "",
      teacherType: "",
      classTeacher: "",
      section: "",
      designation: "",
      department: "",
    },
    payrollDetails: {
      basicPay: "",
      gradePay: "",
      vpf: "",
      busDeduction: "",
      esiApplied: "",
      hraApplied: "",
      taAllowanceApplied: "",
      bankAccountNumber: "",
      ifscCode: "",
    },
    pfDetails: {
      pfApplied: "",
      pfAccountNumber: "",
      pfJoiningDate: "",
      uanNumber: "",
      nomineeName: "",
      nomineeRelation: "",
    },
  });

  const handleSendMobileOtp = async () => {
    setOtpSending(true);
    try {
      const response = await axios.post(`${server}/AppLogin`, {
        userId: staffId,
        type: "staff",
      });

      if (response.status === 200 && response.data?.message?.includes("OTP")) {
        setOtpDigits(["", "", "", ""]);
        setOtpModalVisible(true);
        toast.success("OTP Sent to Mobile No.", {
          position: "top-right",
        });
      } else {
        toast.error("Failed to send OTP", { position: "top-right" });
      }
    } catch (error) {
      console.error("Send OTP Error:", error?.response?.data || error.message);
      toast.error("Please try again", { position: "top-right" });
    } finally {
      setOtpSending(false);
    }
  };

  const handleResendMobileOtp = async () => {
    try {
      setIsResendDisabled(true);
      setResendTimer(30);

      const response = await axios.post(`${server}/ResendAppOtp`, {
        userId: staffId,
        type: "staff",
      });

      if (response.data?.status === "success") {
        setOtpDigits(["", "", "", ""]);
        otpInputsRef.current[0]?.focus();
        toast.success("OTP Resent", { position: "top-right" });

        const interval = setInterval(() => {
          setResendTimer((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              setIsResendDisabled(false);
              return 30;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        toast.error("Failed to Resend OTP", { position: "top-right" });
        setIsResendDisabled(false);
      }
    } catch (error) {
      toast.error("Error Resending OTP", { position: "top-right" });
      setIsResendDisabled(false);
    }
  };

  const handleVerifyMobileOtp = async (otpFromChange) => {
    const enteredOtp = (otpFromChange || otpDigits).join("");
    if (enteredOtp.length < 4) return;

    setOtpVerifying(true);
    try {
      const response = await axios.post(`${server}/VerifyAppOtp`, {
        userId: staffId,
        type: "staff",
        otp: enteredOtp,
      });

      if (response.data?.token) {
        setMobileLocked(false);
        setOtpModalVisible(false);
        toast.success("Verified Mobile No. - Change Now", {
          position: "top-right",
        });
      } else {
        toast.error("Incorrect OTP", { position: "top-right" });
      }
    } catch (error) {
      toast.error("Verification Failed", { position: "top-right" });
    } finally {
      setOtpVerifying(false);
    }
  };

  const handleOtpDigitChange = (text, index) => {
    const newOtp = [...otpDigits];
    newOtp[index] = text;
    setOtpDigits(newOtp);

    if (text && index < otpInputsRef.current.length - 1) {
      otpInputsRef.current[index + 1].focus();
    }

    const allFilled = newOtp.every((d) => d !== "");
    if (allFilled) handleVerifyMobileOtp(newOtp);
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && otpDigits[index] === "" && index > 0) {
      otpInputsRef.current[index - 1].focus();
    }
  };

  useEffect(() => {
    const fetchStaff = async () => {
      if (!staffId) {
        setError("Please enter Staff Id");
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${server}/get_staff_data_mongodb`,
          { staffId: staffId },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        const staffData = response.data?.["body-json"]?.body;
        if (staffData) {
          setFormData((prev) => ({
            ...prev,
            ...staffData,
          }));
          setStaffData(staffData);
        } else {
          setError("No Staff Data Found");
        }
      } catch (err) {
        setError("Student not found or API error.");
      } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, [staffId]);

  const countFilledFields = (obj) => {
    return Object.values(obj).filter(
      (val) => val !== "" && val !== null && val !== undefined,
    ).length;
  };

  const handleNestedChange = (section, name, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));
  };

  useEffect(() => {
    axios
      .get(`${server}/getAllBusRoutesMongoDb`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const routes = response.data["body-json"]?.body?.routes;
        if (Array.isArray(routes)) {
          setTransport(routes);
        } else {
          console.error("Invalid data format from API", response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (uploading) {
      toast.warn("Please Wait, Uploading Image", {
        position: "top-right",
      });
      return;
    }

    const { _id, ...updatePayload } = formData;

    try {
      const response = await fetch(`${server}/update_staff_mongodb`, {
        method: "POST",
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(updatePayload),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Staff Updated", { position: "top-right" });
        navigate("/staff-directory");
      } else {
        toast.error("Please Try Again", { position: "top-right" });
      }
    } catch (error) {
      alert("An error occurred while submitting the form.");
    }
  };

  const handleUploadStaffImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));
    setUploading(true);

    try {
      const { data } = await axios.post(`${server}/staff_presigned`, {
        fileName: file.name,
      });
      const uploadDetails = data?.["body-json"]?.body?.uploadDetails?.[0];
      if (!uploadDetails?.signedUrl || !uploadDetails?.key) {
        throw new Error("Invalid upload details from server");
      }
      await axios.put(uploadDetails.signedUrl, file, {
        headers: { "Content-Type": file.type },
      });
      setImage(uploadDetails.key);
      setFormData((prev) => ({
        ...prev,
        basicDetails: {
          ...prev.basicDetails,
          staffImage: uploadDetails.key,
        },
      }));
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setUploading(false);
    }
  };

  const handleLeftStaff = async () => {
    const result = await MySweetAlert.fire({
      title: "Are you sure?",
      text: "Do you want to left this staff?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, mark as left!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          "https://7otfgyv0ke.execute-api.ap-south-1.amazonaws.com/prod/addMemberToLeftStaff",
          {
            method: "POST",
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ staffId }),
          },
        );

        if (response.ok) {
          toast.success("Marked as Left", { position: "top-right" });
          navigate("/staff-directory");
        } else {
          toast.error("Failed to add staff to left", { position: "top-right" });
        }
      } catch (error) {
        toast.error("Something went wrong", { position: "top-right" });
      }
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Update Staff</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Human Resource</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Staff Directory</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Update Staff
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingOne">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <span class="me-auto fs-5">
                                1. Basic Information{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.basicDetails),
                                  ).padStart(2, "0")}
                                  /{Object.keys(formData.basicDetails).length})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "Initials",
                                  name: "initials",
                                  type: "select",
                                  options: [
                                    "Mr",
                                    "Mrs",
                                    "Acharya",
                                    "Sri",
                                    "Smt",
                                    "Kri",
                                    "Kr",
                                  ],
                                },
                                {
                                  label: "Full Name",
                                  name: "fullName",
                                  type: "text",
                                },
                                {
                                  label: "Gender",
                                  name: "gender",
                                  type: "select",
                                  options: ["Male", "Female"],
                                },
                                {
                                  label: "Father's Name",
                                  name: "fathersName",
                                  type: "text",
                                },
                                {
                                  label: "Mother's Name",
                                  name: "mothersName",
                                  type: "text",
                                },
                                {
                                  label: "Spouse Name",
                                  name: "spouseName",
                                  type: "text",
                                },
                                {
                                  label: "Category",
                                  name: "category",
                                  type: "select",
                                  options: ["General", "OBC", "SC", "ST"],
                                },
                                {
                                  label: "Blood Group",
                                  name: "bloodGroup",
                                  type: "select",
                                  options: [
                                    "A+",
                                    "A-",
                                    "B+",
                                    "B-",
                                    "AB+",
                                    "AB-",
                                    "O+",
                                    "O-",
                                  ],
                                },
                                {
                                  label: "Religion",
                                  name: "religion",
                                  type: "select",
                                  options: [
                                    "Hindu",
                                    "Muslim",
                                    "Christian",
                                    "Sikh",
                                    "Other",
                                  ],
                                },
                                {
                                  label: "Nationality",
                                  name: "nationality",
                                  type: "select",
                                  options: ["Indian", "Other"],
                                },
                                {
                                  label: "Date of Birth",
                                  name: "dob",
                                  type: "date",
                                },
                                {
                                  label: "Date of Joining",
                                  name: "doj",
                                  type: "date",
                                },
                                {
                                  label: "Marital Status",
                                  name: "maritalStatus",
                                  type: "select",
                                  options: ["Single", "Married", "Other"],
                                },
                                {
                                  label: "Email ID",
                                  name: "emailId",
                                  type: "email",
                                },
                                {
                                  label: "Aadhaar No",
                                  name: "aadharNo",
                                  type: "text",
                                },
                                {
                                  label: "PAN No",
                                  name: "panNo",
                                  type: "text",
                                },
                                {
                                  label: "Basic Qualification",
                                  name: "basicQualification",
                                  type: "select",
                                  options: basicQualificationList,
                                },
                                {
                                  label: "Master Qualification",
                                  name: "masterQualification",
                                  type: "select",
                                  options: masterQualificationList,
                                },
                                {
                                  label: "Professional Qualification",
                                  name: "professionalQualification",
                                  type: "select",
                                  options: professionalQualificationList,
                                },
                                {
                                  label: "Correspondence Address",
                                  name: "correspondenceAddress",
                                  type: "text",
                                  col: 12,
                                },
                                {
                                  label: "Permanent Address",
                                  name: "permanentAddress",
                                  type: "text",
                                  col: 12,
                                },
                              ].map(
                                ({ label, name, type, options, col = 6 }) => (
                                  <div
                                    className={`col-lg-${col} col-12`}
                                    key={name}
                                  >
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData.basicDetails[name]
                                            ? {
                                                label:
                                                  formData.basicDetails[name],
                                                value:
                                                  formData.basicDetails[name],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "basicDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        placeholder={`Enter ${label}`}
                                        name={name}
                                        value={formData.basicDetails[name]}
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "basicDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                ),
                              )}

                              {/* Mobile No. with Lock/OTP verification */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Mobile No.{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control text-dark pe-5"
                                    placeholder="Enter Mobile No."
                                    name="mobNo"
                                    value={formData.basicDetails.mobNo}
                                    disabled={mobileLocked}
                                    onChange={(e) =>
                                      handleNestedChange(
                                        "basicDetails",
                                        "mobNo",
                                        e.target.value,
                                      )
                                    }
                                  />
                                  <span
                                    onClick={() =>
                                      mobileLocked
                                        ? handleSendMobileOtp()
                                        : setMobileLocked(true)
                                    }
                                    className="position-absolute top-50 end-0 translate-middle-y me-3"
                                    style={{ cursor: "pointer" }}
                                    title={
                                      mobileLocked
                                        ? "Verify OTP to edit Mobile No."
                                        : "Lock Mobile No."
                                    }
                                  >
                                    {otpSending ? (
                                      <span
                                        className="spinner-border spinner-border-sm text-secondary"
                                        role="status"
                                      ></span>
                                    ) : (
                                      <i
                                        className={`bi ${
                                          mobileLocked
                                            ? "bi-lock-fill text-secondary"
                                            : "bi-unlock-fill text-success"
                                        }`}
                                      ></i>
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {otpModalVisible && (
                      <div className="modal show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content border border-light rounded-5 p-4">
                            <div className="modal-body text-center">
                              <div className="d-flex justify-content-between">
                                <h4 className="modal-title mb-1">
                                  Verify Mobile No.
                                </h4>
                                <button
                                  type="button"
                                  className="btn bg-primary text-white btn-icon rounded-circle mt-n3"
                                  onClick={() => setOtpModalVisible(false)}
                                >
                                  <i className="bi bi-x-lg"></i>
                                </button>
                              </div>
                              <p className="text-secondary text-start lh-sm mb-4">
                                Enter the OTP sent to the Registered Mobile No.
                                <br />
                                to unlock editing Mobile No.
                              </p>
                              <div className="d-flex justify-content-center gap-1 my-3">
                                {[0, 1, 2, 3].map((_, index) => (
                                  <input
                                    key={index}
                                    ref={(ref) =>
                                      (otpInputsRef.current[index] = ref)
                                    }
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={otpDigits[index]}
                                    onChange={(e) =>
                                      handleOtpDigitChange(
                                        e.target.value,
                                        index,
                                      )
                                    }
                                    onKeyDown={(e) =>
                                      handleOtpKeyDown(e, index)
                                    }
                                    className="form-control text-center fw-bold fs-4"
                                    style={{ width: "50px", height: "50px" }}
                                  />
                                ))}
                              </div>

                              <div className="d-flex justify-content-center align-items-center">
                                {otpVerifying && (
                                  <div
                                    className="spinner-border spinner-border-sm text-primary mb-2"
                                    role="status"
                                  ></div>
                                )}
                              </div>

                              <button
                                type="button"
                                className="btn btn-sm"
                                disabled={isResendDisabled}
                                onClick={handleResendMobileOtp}
                              >
                                Not Received OTP ?
                                <span className="text-primary ms-2">
                                  {isResendDisabled
                                    ? `Resend OTP in ${resendTimer}s`
                                    : "Resend OTP"}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingTwo">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-controls="collapseTwo"
                            >
                              <span class="me-auto fs-5">
                                2. Leave Details{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.leaveDetails),
                                  ).padStart(2, "0")}
                                  /
                                  {String(
                                    Object.keys(formData.leaveDetails).length,
                                  ).padStart(2, "0")}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "Casual Leave",
                                  name: "totalCl",
                                  type: "number",
                                  required: true,
                                },
                                {
                                  label: "Medical Leave",
                                  name: "totalMl",
                                  type: "number",
                                  required: true,
                                },
                              ].map(
                                ({ label, name, type, options, required }) => (
                                  <div className="col-lg-6 col-12" key={name}>
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>

                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData[name]
                                            ? {
                                                label:
                                                  formData.leaveDetails[name],
                                                value:
                                                  formData.leaveDetails[name],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "leaveDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        name={name}
                                        value={formData.leaveDetails[name]}
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "leaveDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${label}`}
                                        required={required}
                                      />
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingFive">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFive"
                              aria-controls="collapseFive"
                            >
                              <span class="me-auto fs-5">
                                3. Category Details{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.categoryDetails),
                                  ).padStart(2, "0")}
                                  /
                                  {String(
                                    Object.keys(formData.categoryDetails)
                                      .length,
                                  ).padStart(2, "0")}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseFive"
                            class="collapse"
                            aria-labelledby="headingFive"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "Staff Category",
                                  name: "staffCategory",
                                  type: "select",
                                  options: [
                                    "Teaching",
                                    "Non Teaching",
                                    "Supporting Staff",
                                  ],
                                  required: true,
                                },
                                {
                                  label: "Teacher Type",
                                  name: "teacherType",
                                  type: "select",
                                  options: [
                                    "TGT",
                                    "PGT",
                                    "PRT",
                                    "PRIMARY TEACHER",
                                    "OTHER",
                                  ],
                                },
                                {
                                  label: "Class Teacher",
                                  name: "classTeacher",
                                  type: "select",
                                  options: [
                                    "Not a Class Teacher",
                                    ...classList,
                                  ],
                                },
                                {
                                  label: "Section",
                                  name: "section",
                                  type: "select",
                                  options: sectionList,
                                },
                                {
                                  label: "Designation",
                                  name: "designation",
                                  type: "select",
                                  options: designationList,
                                  required: true,
                                },
                                {
                                  label: "Department",
                                  name: "department",
                                  type: "select",
                                  options: departmentList,
                                  required: true,
                                },
                              ].map(
                                ({ label, name, type, options, required }) => (
                                  <div className="col-lg-6 col-12" key={name}>
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>

                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData.categoryDetails[name]
                                            ? {
                                                label:
                                                  formData.categoryDetails[
                                                    name
                                                  ],
                                                value:
                                                  formData.categoryDetails[
                                                    name
                                                  ],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "categoryDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        name={name}
                                        value={
                                          formData.categoryDetails[name] || ""
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "categoryDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${label}`}
                                        required={required}
                                      />
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {(userRole?.includes("Master Admin") ||
                      userRole?.includes("Admin")) && (
                      <>
                        <div class="px-5 py-3 mt-1 bg-white rounded-4">
                          <div
                            class="accordion accordion-flush"
                            id="accordionExample"
                          >
                            <div id="headingThree">
                              <h3 class="m-0 fs-list">
                                <a
                                  href="#"
                                  class="d-flex align-items-center text-inherit"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseThree"
                                  aria-controls="collapseThree"
                                >
                                  <span class="me-auto fs-5">
                                    4. Payroll Details{" "}
                                    <span className="ms-3 text-secondary">
                                      (
                                      {String(
                                        countFilledFields(
                                          formData.payrollDetails,
                                        ),
                                      ).padStart(2, "0")}
                                      /
                                      {String(
                                        Object.keys(formData.payrollDetails)
                                          .length,
                                      ).padStart(2, "0")}
                                      )
                                    </span>
                                  </span>
                                  <div className="d-flex align-items-center">
                                    <span class="badge bg-secondary-soft me-3 px-3">
                                      Locked
                                    </span>
                                    <div class="form-check form-switch me-4">
                                      <input
                                        type="checkbox"
                                        class="form-check-input m-0"
                                        checked
                                      />
                                    </div>
                                    <span className="collapse-toggle">
                                      <i class="bi bi-chevron-down"></i>
                                    </span>
                                  </div>
                                </a>
                              </h3>

                              <div
                                id="collapseThree"
                                class="collapse"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="row g-2 mt-2 mb-3">
                                  {[
                                    {
                                      label: "Basic Pay",
                                      name: "basicPay",
                                      type: "number",
                                    },
                                    {
                                      label: "Grade Pay",
                                      name: "gradePay",
                                      type: "number",
                                    },
                                    {
                                      label: "VPF",
                                      name: "vpf",
                                      type: "number",
                                    },
                                    {
                                      label: "Bus Deduction",
                                      name: "busDeduction",
                                      type: "select",
                                      options: ["Yes", "No"],
                                    },
                                    {
                                      label: "ESI Applied",
                                      name: "esiApplied",
                                      type: "select",
                                      options: ["Yes", "No"],
                                    },
                                    {
                                      label: "HRA Applied",
                                      name: "hraApplied",
                                      type: "select",
                                      options: ["Yes", "No"],
                                    },
                                    {
                                      label: "TA Allowance Applied",
                                      name: "taAllowanceApplied",
                                      type: "select",
                                      options: ["Yes", "No"],
                                    },
                                    {
                                      label: "Bank Account Number",
                                      name: "bankAccountNumber",
                                      type: "text",
                                    },
                                    {
                                      label: "IFSC Code",
                                      name: "ifscCode",
                                      type: "text",
                                    },
                                  ].map(
                                    ({
                                      label,
                                      name,
                                      type,
                                      options,
                                      required,
                                    }) => (
                                      <div
                                        className="col-lg-6 col-12"
                                        key={name}
                                      >
                                        <label className="form-label mb-1 ms-3">
                                          {label}{" "}
                                          {required && (
                                            <span className="text-danger">
                                              *
                                            </span>
                                          )}
                                        </label>

                                        {type === "select" ? (
                                          <Select
                                            name={name}
                                            options={options.map((opt) => ({
                                              label: opt,
                                              value: opt,
                                            }))}
                                            value={
                                              formData.payrollDetails[name]
                                                ? {
                                                    label:
                                                      formData.payrollDetails[
                                                        name
                                                      ],
                                                    value:
                                                      formData.payrollDetails[
                                                        name
                                                      ],
                                                  }
                                                : null
                                            }
                                            onChange={(selectedOption) =>
                                              handleNestedChange(
                                                "payrollDetails",
                                                name,
                                                selectedOption?.value || "",
                                              )
                                            }
                                            placeholder={`Select ${label}`}
                                          />
                                        ) : (
                                          <input
                                            type={type}
                                            className="form-control text-dark"
                                            name={name}
                                            value={
                                              formData.payrollDetails[name] ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleNestedChange(
                                                "payrollDetails",
                                                e.target.name,
                                                e.target.value,
                                              )
                                            }
                                            placeholder={`Enter ${label}`}
                                            required={required}
                                          />
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="px-5 py-3 mt-1 bg-white rounded-4">
                          <div
                            class="accordion accordion-flush"
                            id="accordionExample"
                          >
                            <div id="headingFour">
                              <h3 class="m-0 fs-list">
                                <a
                                  href="#"
                                  class="d-flex align-items-center text-inherit"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFour"
                                  aria-controls="collapseFour"
                                >
                                  <span class="me-auto fs-5">
                                    5. PF Details{" "}
                                    <span className="ms-3 text-secondary">
                                      (
                                      {String(
                                        countFilledFields(formData.pfDetails),
                                      ).padStart(2, "0")}
                                      /
                                      {String(
                                        Object.keys(formData.pfDetails).length,
                                      ).padStart(2, "0")}
                                      )
                                    </span>
                                  </span>
                                  <div className="d-flex align-items-center">
                                    <span class="badge bg-secondary-soft me-3 px-3">
                                      Locked
                                    </span>
                                    <div class="form-check form-switch me-4">
                                      <input
                                        type="checkbox"
                                        class="form-check-input m-0"
                                        checked
                                      />
                                    </div>
                                    <span className="collapse-toggle">
                                      <i class="bi bi-chevron-down"></i>
                                    </span>
                                  </div>
                                </a>
                              </h3>

                              <div
                                id="collapseFour"
                                class="collapse"
                                aria-labelledby="headingFour"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="row g-2 mt-2 mb-3">
                                  {[
                                    {
                                      label: "PF Applied",
                                      name: "pfApplied",
                                      type: "select",
                                      options: ["Yes", "No"],
                                    },
                                    {
                                      label: "PF A/C No",
                                      name: "pfAccountNumber",
                                      type: "text",
                                    },
                                    {
                                      label: "PF Joining Date",
                                      name: "pfJoiningDate",
                                      type: "date",
                                    },
                                    {
                                      label: "UAN No",
                                      name: "uanNumber",
                                      type: "text",
                                    },
                                    {
                                      label: "Nominee Name",
                                      name: "nomineeName",
                                      type: "text",
                                    },
                                    {
                                      label: "Relation With Nominee",
                                      name: "nomineeRelation",
                                      type: "select",
                                      options: ["Father", "Mother", "Spouse"],
                                    },
                                  ].map(
                                    ({
                                      label,
                                      name,
                                      type,
                                      required,
                                      options,
                                    }) => (
                                      <div
                                        className="col-lg-6 col-12"
                                        key={name}
                                      >
                                        <label className="form-label mb-1 ms-3">
                                          {label}{" "}
                                          {required && (
                                            <span className="text-danger">
                                              *
                                            </span>
                                          )}
                                        </label>

                                        {type === "select" ? (
                                          <Select
                                            name={name}
                                            options={options.map((opt) => ({
                                              label: opt,
                                              value: opt,
                                            }))}
                                            value={
                                              formData.pfDetails[name]
                                                ? {
                                                    label:
                                                      formData.pfDetails[name],
                                                    value:
                                                      formData.pfDetails[name],
                                                  }
                                                : null
                                            }
                                            onChange={(selectedOption) =>
                                              handleNestedChange(
                                                "pfDetails",
                                                name,
                                                selectedOption?.value || "",
                                              )
                                            }
                                            placeholder={`Select ${label}`}
                                          />
                                        ) : (
                                          <input
                                            type={type}
                                            className="form-control text-dark"
                                            name={name}
                                            value={
                                              formData.pfDetails[name] || ""
                                            }
                                            onChange={(e) =>
                                              handleNestedChange(
                                                "pfDetails",
                                                e.target.name,
                                                e.target.value,
                                              )
                                            }
                                            placeholder={`Enter ${label}`}
                                            required={required}
                                          />
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="my-3 d-flex float-end me-5">
                      <button
                        type="submit"
                        class="btn btn-success mt-2 px-6"
                        disabled={uploading}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>

                <div className="col-lg-4">
                  {staffData && (
                    <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1">
                      <div className="d-flex flex-column align-items-center">
                        <div>
                          <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative overflow-hidden me-2">
                            {preview || staffData?.basicDetails?.staffImage ? (
                              <img
                                src={
                                  preview || staffData?.basicDetails?.staffImage
                                }
                                alt="Preview"
                                width="150"
                                height="150"
                                className="object-fit-cover rounded-3"
                              />
                            ) : (
                              <span className="position-absolute mt-2">
                                <i className="bi bi-image fs-2"></i>
                              </span>
                            )}

                            {uploading && (
                              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3">
                                <div
                                  className="spinner-border text-light"
                                  role="status"
                                ></div>
                              </div>
                            )}

                            <input
                              className="form-control border-0 opacity-0 position-absolute top-0 start-0 w-100 h-100"
                              type="file"
                              onChange={(event) => {
                                handleUploadStaffImage(event);
                                setPreview(
                                  URL.createObjectURL(event.target.files[0]),
                                );
                              }}
                              accept="image/*"
                              disabled={uploading}
                            />
                          </div>
                          <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                              className="w-100 position-absolute p-2 rounded-4"
                              alt="QR"
                            />
                          </div>
                        </div>
                        <div className="mt-4 text-center">
                          <h3 class="m-0 fs-4 lh-sm">
                            {formData?.basicDetails?.fullName || "Full Name"} (
                            {formData?.staffId})
                          </h3>
                          <p className="m-0">
                            {formData?.basicDetails?.doj || "Date of Joining"}
                          </p>
                          <p className="mt-2 mb-0 text-danger lh-sm">
                            (+91) {formData?.basicDetails?.mobNo || "Mobile No"}
                            <br />
                            {formData?.basicDetails?.emailId || "Email ID"}
                          </p>

                          <p className="mt-2 mb-0 text-dark lh-sm">
                            {formData?.basicDetails?.fathersName ||
                              "Father's Name"}
                            <br />
                            {formData?.basicDetails?.mothersName ||
                              "Mother's Name"}
                          </p>

                          <div className="mt-4">
                            <span
                              onClick={handleLeftStaff}
                              className="btn btn-warning btn-sm px-4 rounded-3 fw-normal"
                            >
                              Left Staff
                            </span>
                          </div>

                          <p className="m-0 lh-sm mt-4 text-capitalize">
                            {(
                              formData?.basicDetails?.permanentAddress ||
                              "Permanent Address"
                            )
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default UpdateStaff;
